export default __webpack_public_path__ + "static/media/camel.0e5df5a0.png";